<template>
  <v-container>
    <v-progress-circular
      v-if="loading"
      :indeterminate="true"
    />
    <v-row v-else>
      <v-col
        cols="12"
        lg="8"
      >
        <v-container>
          <v-row>
            <v-col md="12">
              <base-material-card
                color="info"
                :title="product.displayName"
              >
                <v-form>
                  <v-container class="py-0">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                      >
                        <div>
                          <h6 class="title text-uppercase">
                            {{ $t('Pages.Product.Titles.Vendor') }}
                          </h6>
                          <p class="ml-3 material">
                            {{ product.vendorDisplayName }}
                          </p>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                      >
                        <div>
                          <h6 class="title text-uppercase">
                            {{ $t('Pages.Product.Titles.ActiveCount') }}
                          </h6>
                          <p class="ml-3 material">
                            {{ priceInfo.activeSubscriptionCount }}
                          </p>
                        </div>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                      >
                        <div>
                          <h6
                            v-if="priceInfo.priceItems && priceInfo.priceItems.length > 0"
                            class="title text-uppercase"
                          >
                            {{ $t('Pages.Product.Titles.ResellerPricing') }}
                          </h6>
                          <pricing-table
                            :price-items="priceInfo.priceItems"
                            :active-subscription-count="priceInfo.activeSubscriptionCount"
                          />
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                      >
                        <div>
                          <h6
                            v-if="priceInfo.priceItems && priceInfo.priceItems.length > 0"
                            class="title text-uppercase text-right"
                          >
                            {{ $t('Pages.Product.Titles.Msrp') }}
                          </h6>
                          <pricing-table
                            :price-items="priceInfo.priceItems"
                            :is-msrp="true"
                            :no-active-state="true"
                            align="right"
                          />
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <div>
                          <h6 class="title text-uppercase">
                            {{ $t('Pages.Product.Titles.Description') }}
                          </h6>
                          <div
                            class="ml-3 material"
                            v-html="productDetails.description"
                          />
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <div>
                          <h6 class="title text-uppercase">
                            {{ $t('Pages.Product.Titles.Variants') }}
                          </h6>
                          <v-tabs
                            vertical
                            class="pl-0"
                          >
                            <v-tab
                              v-for="(item, index) in variantsPriceInfo"
                              :key="index"
                              class="text-left text-primary dense"
                            >
                              <v-icon left>
                                mdi-view-grid-outline
                              </v-icon>
                              {{ item.name }}
                            </v-tab>

                            <v-tab-item
                              v-for="(item, index) in variantsPriceInfo"
                              :key="index"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="7"
                                  class="py-0"
                                >
                                  <div class="text-right">
                                    <h6
                                      v-if="item.priceItems && item.priceItems.length > 0"
                                      class="title text-uppercase"
                                    >
                                      {{ $t('Pages.Product.Titles.ResellerPricing') }}
                                    </h6>
                                    <pricing-table
                                      :price-items="item.priceItems"
                                      :active-subscription-count="item.activeSubscriptionCount"
                                      align="right"
                                    />
                                  </div>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="5"
                                  class="py-0"
                                >
                                  <div class="text-right">
                                    <h6
                                      v-if="item.priceItems && item.priceItems.length > 0"
                                      class="title text-uppercase"
                                    >
                                      {{ $t('Pages.Product.Titles.Msrp') }}
                                    </h6>
                                    <pricing-table
                                      :price-items="item.priceItems"
                                      :is-msrp="true"
                                      :no-active-state="true"
                                      align="right"
                                    />
                                  </div>
                                </v-col>
                              </v-row>
                            </v-tab-item>
                          </v-tabs>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <template v-slot:actions>
                  <v-row
                    no-gutters
                    align="center"
                  >
                    <v-col
                      cols="auto"
                      class="mr-auto"
                    >
                      <v-icon class="mr-1">
                        mdi-menu-left
                      </v-icon>
                      <router-link
                        :to="{ name: 'Products', }"
                      >
                        <span>{{ $t('General.Links.All', ['products']) }}</span>
                      </router-link>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        v-if="uid"
                        class="font-weight-light v-btn--tight"
                        color="success"
                        loading:loading.commit
                        :to="{ name: 'ProductOrder', params: { productUid: product.uid }, }"
                      >
                        {{ $t('General.Buttons.AddToBasket') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </base-material-card>
            </v-col>

            <v-col
              v-if="productDetails.videos && productDetails.videos.length > 0"
              cols="12"
              md="6"
            >
              <base-material-card
                inline
                icon="mdi-video"
                :title="$t('Pages.Product.Titles.Videos')"
                class="px-5 py-3"
              >
                <v-simple-table>
                  <tbody>
                    <tr
                      v-for="(item, index) in productDetails.videos"
                      :key="index"
                    >
                      <td
                        class="link"
                        @click="openLink(item.url)"
                      >
                        {{ item.name }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </base-material-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col
        v-if="(productDetails.faqs && productDetails.faqs.length > 0) || (productDetails.kbArticles && productDetails.kbArticles.length > 0)"
        cols="12"
        lg="4"
      >
        <v-container>
          <v-row>
            <v-col
              v-if="productDetails.faqs && productDetails.faqs.length > 0"
              cols="12"
              md="6"
              lg="12"
            >
              <base-material-card
                inline
                icon="mdi-map-marker-question-outline"
                :title="$t('Pages.Product.Titles.Faqs')"
                class="px-5 py-3"
              >
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(item, index) in productDetails.faqs"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      {{ item.question }}
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <div v-html="item.anwser" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </base-material-card>
            </v-col>
            <v-col
              v-if="productDetails.kbArticles && productDetails.kbArticles.length > 0"
              cols="12"
              md="6"
              lg="12"
            >
              <base-material-card
                inline
                icon="mdi-newspaper"
                :title="$t('Pages.Product.Titles.KbArticles')"
                class="px-5 py-3"
              >
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(item, index) in productDetails.kbArticles"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      {{ item.name }}
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <div v-html="item.bodyText" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </base-material-card>
            </v-col>
          </v-row>
        </v-container>
        <v-col
          v-if="productDetails.dataSheets && productDetails.dataSheets.length > 0"
          cols="12"
        >
          <base-material-card
            inline
            icon="mdi-file-chart-outline"
            :title="$t('Pages.Product.Titles.DataSheets')"
            class="px-5 py-3"
          >
            <v-simple-table>
              <tbody>
                <tr
                  v-for="(item, index) in productDetails.dataSheets"
                  :key="index"
                >
                  <td
                    class="link"
                    @click="openLink(item.url)"
                  >
                    {{ item.name }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </base-material-card>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import productService from '@/services/productService'
  import PricingTable from '../views/dashboard/components/PricingTable.vue'

  export default {
    components: {
      PricingTable,
    },
    props: {
      uid: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      loading: true,
      priceInfo: [],
      variantsPriceInfo: [],
    }),
    computed: {
      product () {
        return this.$store.state.products.list.find(product => product.uid === this.uid)
      },
      productDetails () {
        return this.$store.state.products.detailsList.find(detail => detail.nodeId === this.product.contentNodeId)
      },
    },
    created: async function () {
      if (this.$store.state.products.list.length === 0) {
        await this.$store.dispatch('RefreshProducts')
      }
      if (!this.product.description) {
        await this.$store.dispatch('GetProductDetails', this.product.uid)
      }
      // we do not save the priceInfo in the store as this should be as up to date as possible
      var priceInfoApiResult = await productService.getAllPrices(this.uid)
      if (priceInfoApiResult.success && priceInfoApiResult.value) {
        this.priceInfo = priceInfoApiResult.value.find(p => !p.isProductVariantPricing)
        this.variantsPriceInfo = priceInfoApiResult.value.filter(p => p.isProductVariantPricing)
      }

      this.loading = false
    },
    beforeMount () {

    },
    methods: {
      openLink: function (url) {
        window.open(url, '_blank')
      },
    },
  }
</script>

<style>
  td.link{cursor:pointer}
</style>
